import React from "react";

const Loading = ({ align }) => {
  return (
    <div className="relative flex justify-center items-center bg-neutral-white h-screen w-full z-40">
      <div className="animate-spin rounded-full h-20 w-20 border-b-2 border-primary-600 "></div>
    </div>
  );
};

export default Loading;
